import React, { useMemo } from 'react';
import { Code2, ChevronDown, ChevronRight } from 'lucide-react';
import { CATEGORY_LABELS, CATEGORY_ORDER } from './memberDetailConstants';

export default function MemberTechStackSection({
  techStacks,
  techCategoriesOpen,
  toggleTechCategory,
}: any) {
  const techByCategory = useMemo(
    () =>
      (techStacks || []).reduce((acc, t) => {
        const cat = t.category || 'other';
        if (!acc[cat]) acc[cat] = [];
        acc[cat].push(t);
        return acc;
      }, {}),
    [techStacks]
  );

  const categoryOrder = CATEGORY_ORDER;

  return (
    <div className="section-block-mdl">
      {!techStacks?.length ? (
        <p className="text-slate-400">No tech stack data for this member’s repositories yet.</p>
      ) : (
        <div className="card-mdl-static overflow-hidden">
          <div className="p-4 border-b border-dark-border flex items-center gap-2 text-slate-300">
            <Code2 className="w-5 h-5 text-vivid-purple" />
            <span className="font-medium">Technologies by category</span>
          </div>
          <div className="p-4 space-y-0 divide-y divide-dark-border">
            {categoryOrder.map((cat) => {
              const items = techByCategory[cat];
              if (!items?.length) return null;
              const label = CATEGORY_LABELS[cat] || cat;
              const isOpen = techCategoriesOpen.has(cat);
              return (
                <div key={cat}>
                  <button
                    type="button"
                    onClick={() => toggleTechCategory(cat)}
                    className="w-full flex items-center gap-2 py-3 text-left text-sm font-semibold text-slate-300 hover:bg-dark-base/50 transition-colors"
                    aria-expanded={isOpen}
                  >
                    {isOpen ? (
                      <ChevronDown className="w-4 h-4 flex-shrink-0 text-slate-500" />
                    ) : (
                      <ChevronRight className="w-4 h-4 flex-shrink-0 text-slate-500" />
                    )}
                    <span className="uppercase tracking-wide">{label}</span>
                    <span className="text-slate-400 font-normal">({items.length})</span>
                  </button>
                  {isOpen && (
                    <div className="pb-3 flex flex-wrap gap-2">
                      {items.map((t, i) => (
                        <span
                          key={`${t.name}-${t.source}-${i}`}
                          className="inline-flex items-center rounded-lg bg-dark-elevated px-3 py-1.5 text-sm font-medium text-slate-200"
                        >
                          {t.name}
                          {t.source && (
                            <span className="ml-1.5 text-xs text-slate-400">({t.source})</span>
                          )}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
